import React, { useState } from "react"
import { useDropzone, FileWithPath } from "react-dropzone"
import { Stack, Typography } from "@mui/material"

export default function UserProfileUpload({
  profileImage,
  setProfileImage,
  userPicture,
}: {
  profileImage: FileWithPath | undefined
  setProfileImage: React.Dispatch<
    React.SetStateAction<FileWithPath | undefined>
  >
  userPicture?: string
}) {
  const [profileImagePreview, setProfileImagePreview] = useState<string>(
    userPicture || ""
  )

  const onProfileDrop = (acceptedFiles: FileWithPath[]) => {
    setProfileImage(acceptedFiles[0])
    setProfileImagePreview(URL.createObjectURL(acceptedFiles[0]))
  }

  const {
    getRootProps: getProfileRootProps,
    getInputProps: getProfileInputProps,
  } = useDropzone({
    accept: {
      "image/*": [],
    },

    onDrop: onProfileDrop,
    maxFiles: 1,
  })

  const ProfileImagePreviewComponent = () => {
    return (
      <div key={profileImage?.name}>
        <div style={{ borderRadius: "50%" }}>
          <img
            width={"100%"}
            height="120px"
            style={{ borderRadius: "50%" }}
            src={profileImagePreview}
            onLoad={() => {
              URL.revokeObjectURL(profileImagePreview)
            }}
          />
        </div>
      </div>
    )
  }

  return (
    <section>
      <Stack direction="column" width="100%" spacing={2}>
        <Typography variant="h4">Profile Picture</Typography>
        <Stack width="100%" direction="row" justifyContent="space-between">
          <div
            {...getProfileRootProps()}
            style={{
              border: "2px dashed #000",
              padding: "20px",
              cursor: "pointer",
              maxWidth: "30%",
              maxHeight: "120px",
            }}
          >
            <input {...getProfileInputProps()} />
            <p>Drag 'n' drop some files here, or click to select files</p>
          </div>
          {profileImagePreview.length && <ProfileImagePreviewComponent />}
        </Stack>
      </Stack>
    </section>
  )
}
